import React, { memo, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Layout
import DocumentsLayout from '../../../layouts/DocumentsLayout'
import AppPageHeader from '../../../components/AppPageHeader'
// Component
import UnreadText from '../../../components/UnreadText/UnreadText'
import AdvanceFilterBlock from './AdvanceFilterBlock'
// Style Component
import { TableFooterActionWrapper } from './InternalDocumentOutgoingDocPageStyled'
// Ant design
import { PlusOutlined } from '@ant-design/icons'
import { Button, Empty, Input, Pagination, Select, message } from 'antd'
// Other
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import { useLocation, withRouter } from 'react-router-dom'
import AccessControlAction from '../../../components/AccessControlAction'
import {
  AddCircleOutlineIcon,
  CheckReadOutlineIcon,
  ExportOutlineIcon,
  MagnifierOutlineIcon,
  PrinterMinimalisticOutlineIcon,
} from '../../../components/AppIcon'
import { EmptyText } from '../../../components/Common/CellText'
import TableComponent from '../../../components/Common/TableComponent'
import { systemName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_SLASH,
  DOCUMENT_TYPE,
} from '../../../constants'
import utils from '../../../utils'
import InternalDocumentOutgoingDocAdvanceFilterV2 from './InternalDocumentOutgoingDocAdvanceFilterV2'
import { AppTable } from '../../../components/AppTable/AppTable'
import { AppTablePagination } from '../../../components/AppTable/AppTablePagination'

const { Search } = Input
const { Option } = Select

const InternalDocumentOutgoingOutgoingDocPage = props => {
  const {
    history,
    internalDocumentStore,
    loadingAnimationStore,
    bookStore,
    authorityStore,
    commandStore,
  } = props

  const {
    internalDocumentOutgoingList,
    internalDocumentOutgoingListTotalCount,
    queryParamsOutgoing,
  } = internalDocumentStore

  const { from, onlyUnread, page, size } = history.location.state || {}
  useEffect(() => {
    handleChangeParams({
      // only_unread: onlyUnread,
      page: page,
      size: size,
    })
  }, [])

  const location = useLocation()
  const queryStringParse = queryString.parse(location.search)

  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)
  const [countFilter, setCountFilter] = useState(0)
  const [isRefreshPage, setIsRefreshPage] = useState(true)
  // check hiển thị phân trang khi load dữ liệu
  const [checkPagination, setCheckPagination] = useState(true)

  const [markAsReadLoading, setMarkAsReadLoading] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [
    selectedUnreadInterOutgoing,
    setSelectedUnreadInterOutgoing,
  ] = useState(false)
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }

  useEffect(() => {
    const restoreSelectedRows = () => {
      const selectedRowsData = sessionStorage.getItem(
        'selectedRowsInterOutgoing'
      )
      if (selectedRowsData) {
        setSelectedRowKeys(JSON.parse(selectedRowsData))
        sessionStorage.removeItem('selectedRowsInterOutgoing')
      }
    }
    const restoreSelectedUnRead = () => {
      const selectedUnreadData = sessionStorage.getItem(
        'selectedUnreadInterOutgoing'
      )
      if (selectedUnreadData) {
        setSelectedUnreadInterOutgoing(JSON.parse(selectedUnreadData))
        handleChangeParams({ only_unread: JSON.parse(selectedUnreadData) })
        sessionStorage.removeItem('selectedUnreadInterOutgoing')
      }
    }
    restoreSelectedUnRead()
    restoreSelectedRows()
  }, [])

  const handleRowClick = record => {
    sessionStorage.setItem(
      'selectedUnreadInterOutgoing',
      JSON.stringify(selectedUnreadInterOutgoing)
    )
    sessionStorage.setItem(
      'selectedRowsInterOutgoing',
      JSON.stringify(selectedRowKeys)
    )
    history.push(`/internal-document/outgoing-document/view/${record.code}`)
  }

  const NGAY_DI_WIDTH = 140
  const SO_HIEU_WIDTH = 140
  const TRICH_YEU_WIDTH = 300
  const BO_PHAN_DU_THAO_WIDTH = 250
  const NGUOI_KY_WIDTH = 180
  const SCROLL_WIDTH = 1000

  const tableColumns = [
    {
      title: 'Ngày ban hành',
      width: NGAY_DI_WIDTH,
      render: record =>
        record.date_issued ? (
          <UnreadText
            text={moment(record.date_issued).format(DATE_FORMAT_SLASH)}
            isUnread={checkUnread(record)}
            width={NGAY_DI_WIDTH}
          />
        ) : (
          '-'
        ),
    },
    // {
    //   title: 'Ngày đi',
    //   width: NGAY_DI_WIDTH,
    //   render: record => (
    //     <UnreadText
    //       text={moment(record.outgoing_date).format(DATE_FORMAT_SLASH)}
    //       isUnread={checkUnread(record)}
    //       width={NGAY_DI_WIDTH}
    //     />
    //   ),
    // },
    {
      title: 'Số hiệu',
      width: SO_HIEU_WIDTH,
      render: record => (
        <UnreadText
          text={record.document_number}
          isUnread={checkUnread(record)}
          width={SO_HIEU_WIDTH}
        />
      ),
    },
    {
      title: 'Trích yếu',
      width: TRICH_YEU_WIDTH,
      render: record => (
        <UnreadText
          text={record.title}
          isUnread={checkUnread(record)}
          width={TRICH_YEU_WIDTH}
        />
      ),
    },
    {
      title: 'Bộ phận dự thảo',
      width: BO_PHAN_DU_THAO_WIDTH,
      render: record => (
        <UnreadText
          text={record.authority_issued}
          isUnread={checkUnread(record)}
          width={BO_PHAN_DU_THAO_WIDTH}
        />
      ),
    },
    {
      title: 'Người ký',
      width: NGUOI_KY_WIDTH,
      render: record =>
        record.signer ? (
          <UnreadText
            text={record.signer}
            isUnread={checkUnread(record)}
            width={NGUOI_KY_WIDTH}
          />
        ) : (
          <EmptyText>Không có.</EmptyText>
        ),
    },
  ]

  const checkUnread = record => record.status_doc_outgoing === 'UNREAD'

  const exportDocument = useCallback(async () => {
    const col = [
      'Ngày ban hành',
      'Số hiệu',
      'Trích yếu',
      'Bộ phận dự thảo',
      'Người ký',
    ]

    let rows = []
    rows.push(col)

    try {
      setExportLoading(true)
      const res = await internalDocumentStore.getForExportInternalDocumentOutgoingListAll()

      if (res && res.data && res.data.data) {
        res.data.data.map(item => {
          rows.push([
            item.date_issued
              ? moment(item.date_issued).format(DATE_FORMAT_SLASH)
              : '',
            item.document_number,
            item.title,
            item.authority_issued,
            item.signer,
          ])
        })
      }
      utils.exportExcel(
        rows,
        'VBNB - văn bản đi - ' + moment().format('YYYY-MM-DD hmms')
      )
      internalDocumentStore.setQueryParamsOutgoing({
        ...queryParamsOutgoing,
        ...queryStringParse,
      })
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setExportLoading(false)
    }
  }, [queryParamsOutgoing])

  const searchParams = new URLSearchParams(location.search)
  const pageValue = searchParams.get('page') || 0

  sessionStorage.setItem('page', pageValue)

  const handleChangeParams = (params, isResetFilter = false) => {
    if (isResetFilter) {
      internalDocumentStore.setQueryParamsOutgoing({
        page: 0,
        size: 10,
      })
      history.replace(`/internal-document/outgoing-document`)
      return
    }
    internalDocumentStore.setQueryParamsOutgoing({
      ...queryParamsOutgoing,
      page: sessionStorage.getItem('page') || 0,
      fullText: params.fullText ? true : false,
      ...params,
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: sessionStorage.getItem('page') || 0,
        size: 10,
        ...params,
      },
      {
        skipNull: true,
      }
    )

    setSelectedUnreadInterOutgoing(params?.only_unread || false)
    history.replace(
      `/internal-document/outgoing-document?${queryStringStringify}`
    )
  }

  const markAsRead = () => {
    let batchMarkAsRead = []
    selectedRowKeys.forEach(docId => {
      batchMarkAsRead.push(
        internalDocumentStore.getInternalDocumentIncomingById(docId)
      )
    })
    setMarkAsReadLoading(true)
    Promise.all(batchMarkAsRead).finally(() => {
      setMarkAsReadLoading(false)
      setSelectedRowKeys([])
      getInternalDocumentOutgoingList()
    })
    commandStore.getSideMenuCounter([
      'WORK',
      'PROPOSAL',
      'INTERNAL_MESSAGE',
      'INCOMING',
      'OUTGOING',
      'DISTRIBUTE',
      'PROCUREMENT',
    ])
  }

  const handleQuickSearch = title => {
    handleChangeParams({ title: title ? title.trim() : null })
  }

  const handleChangeUnread = event => {
    let only_unread = event?.target?.checked ? true : false
    handleChangeParams({ only_unread: only_unread, page: 0 })
    setSelectedUnreadInterOutgoing(only_unread)
  }

  const onChangePagination = (pageIndex, pageSize) => {
    handleChangeParams({
      page: pageIndex - 1,
      size: pageSize || 10,
      fullText: queryParamsOutgoing?.fullText,
    })
  }

  const getInternalDocumentOutgoingList = async () => {
    try {
      loadingAnimationStore.setTableLoading(true)
      if (queryParamsOutgoing.fullText) {
        await internalDocumentStore.getInternalDocumentOutgoingFullTextList()
      } else {
        await internalDocumentStore.getInternalDocumentOutgoingList()
      }
    } catch (error) {
      console.log(error)
      message.error(error?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.setTableLoading(false)
    }
  }

  useEffect(() => {
    internalDocumentStore.setQueryParamsOutgoing({
      ...queryParamsOutgoing,
      ...queryStringParse,
    })
    ;(async () => {
      try {
        loadingAnimationStore.setTableLoading(true)
        await setCheckPagination(false)
        authorityStore.setAuthorityIssuedsQueryParams({
          type: DOCUMENT_TYPE.OUTGOING,
          key: null,
        })
        await Promise.all([
          authorityStore.getAuthorityIssueds(),
          bookStore.getBookGroup('DI'),
          internalDocumentStore.getInternalDocumentOutgoingList(),
        ])
        setIsRefreshPage(false)
      } catch (err) {
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.setTableLoading(false)
        setCheckPagination(true)
      }
    })()
    return () => {
      internalDocumentStore.clearInternalDocumentOutgoingList()
      bookStore.clearBookGroupList()
      internalDocumentStore.clearQueryParamsOutgoing()
    }
  }, [])

  useEffect(() => {
    if (isRefreshPage) return
    ;(async () => {
      await getInternalDocumentOutgoingList()
    })()
  }, [queryParamsOutgoing])

  useEffect(() => {
    // Đếm số filter hiện tại
    let count = 0
    if (queryStringParse.title) {
      count++
    }
    if (queryStringParse.from_date_issued && queryStringParse.to_date_issued) {
      count++
    }
    if (queryStringParse.document_type) {
      count++
    }
    if (queryStringParse.document_number) {
      count++
    }
    if (queryStringParse.urgency_level) {
      count++
    }
    if (queryStringParse.signer) {
      count++
    }
    if (queryStringParse.book_group_id) {
      count++
    }
    if (queryStringParse.book_id) {
      count++
    }
    if (queryStringParse.authority_name) {
      count++
    }
    setCountFilter(count)
  }, [queryStringParse])

  const [searchInputValue, setSearchInputValue] = useState(
    queryStringParse.title
  )

  useEffect(() => {
    setSearchInputValue(queryStringParse?.title)
  }, [queryStringParse?.title])

  return (
    <DocumentsLayout
      title={
        <AppPageHeader
          title="Danh sách văn bản"
          addon={
            <>
              <Search
                allowClear
                onSearch={value => handleQuickSearch(value)}
                value={searchInputValue}
                onChange={e => setSearchInputValue(e.target.value)}
                maxLength={500}
                placeholder="Tìm kiếm theo Trích yếu / Số hiệu"
                enterButton={
                  <MagnifierOutlineIcon
                    style={{ color: '#000', width: 16, height: 16 }}
                  />
                }
                className="custom-search-input fixed-width"
              />
              <InternalDocumentOutgoingDocAdvanceFilterV2
                handleChangeParams={handleChangeParams}
                queryParamsOutgoing={queryParamsOutgoing}
              />

              <Button
                loading={exportLoading}
                onClick={exportDocument}
                className="custom-ant-button icon-btn">
                <ExportOutlineIcon
                  style={{
                    width: 16,
                    height: 16,
                  }}
                />{' '}
                Xuất dữ liệu
              </Button>
              <AccessControlAction aclActionType={ACL_ACTION_TYPE.create__OUTGOING}>
                <Button
                  icon={
                    <AddCircleOutlineIcon
                      style={{ color: '#fff', width: 16, height: 16 }}
                    />
                  }
                  onClick={() =>
                    history.push('/internal-document/outgoing-document/create')
                  }
                  type={'primary'}
                  className="custom-ant-button icon-btn">
                  Tạo mới văn bản
                </Button>
              </AccessControlAction>
            </>
          }
        />
      }
      selectedKey="outgoing-document"
      linkToIncomingDocument="/internal-document/incoming-document"
      linkToOutgoingDocument="/internal-document/outgoing-document"
      linkToSignDocument="/internal-document/sign-document"
      linkToConfigDocument="/internal-document/config-document/document-books">
      <Helmet>
        <title>
          Văn bản đi | {systemName} Quản lý VB {systemName}
        </title>
      </Helmet>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%',
          marginBottom: '20px',
          flexWrap: 'wrap',
        }}>
        {/* {!showAdvanceFilter ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Search
              style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                width: 300,
              }}
              allowClear
              onSearch={value => handleQuickSearch(value)}
              defaultValue={queryStringParse.title}
              placeholder={'Tìm kiếm theo Trích yếu / Số hiệu'}
            />
            <Space
              style={{
                width: 130,
                verticalAlign: 'middle',
                display: 'inline-block',
                marginLeft: 10,
              }}>
              <Checkbox
                style={{
                  width: '200px',
                }}
                // checked={ queryStringParse?.only_unread || selectedUnreadInterOutgoing}
                // checked={ queryStringParse?.only_unread === 'true'}
                checked={
                  queryParamsOutgoing?.only_unread === 'true' ||
                  queryParamsOutgoing?.only_unread === true
                }
                onChange={handleChangeUnread}>
                Hiển thị văn bản chưa đọc
              </Checkbox>
            </Space>
            <Space
              style={{
                width: 180,
                verticalAlign: 'middle',
                display: 'inline-block',
                marginLeft: 40,
              }}>
              {selectedRowKeys && selectedRowKeys.length > 0 ? (
                <Button
                  loading={markAsReadLoading}
                  onClick={markAsRead}
                  disabled={!selectedRowKeys || selectedRowKeys.length === 0}
                  style={{ marginLeft: '10px' }}>
                  <CheckOutlined />
                  Đánh dấu đã đọc
                </Button>
              ) : (
                <Tooltip placement="top" title={'Chưa chọn đối tượng'}>
                  <Button disabled={true} style={{ marginLeft: '10px' }}>
                    <CheckOutlined />
                    Đánh dấu đã đọc
                  </Button>
                </Tooltip>
              )}
            </Space>
          </div>
        ) : null} */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '5px',
            gap: 12,
          }}>
          <div style={{ marginRight: '5px' }}>
            {/* <span
              className={'count-filter'}
              style={{ display: !countFilter && 'none' }}>
              {countFilter}
            </span> */}
            {/* <Button
              type={showAdvanceFilter ? 'primary' : 'default'}
              ghost={showAdvanceFilter}
              // style={{ marginBottom: showAdvanceFilter ? 10 : 0 }}
              onClick={() => setShowAdvanceFilter(!showAdvanceFilter)}>
              {showAdvanceFilter ? (
                <Space>
                  <CloseCircleOutlined />
                  Ẩn tìm kiếm nâng cao
                </Space>
              ) : (
                <Space>
                  <FilterOutlined />
                  Tìm kiếm nâng cao
                </Space>
              )}
            </Button> */}
          </div>

          {Boolean(selectedRowKeys && selectedRowKeys.length > 0) && (
            <Button
              className="custom-ant-button icon-btn"
              loading={markAsReadLoading}
              onClick={markAsRead}
              disabled={selectedRowKeys.length === 0}
              icon={<CheckReadOutlineIcon />}>
              Đánh dấu đã đọc
            </Button>
          )}
        </div>
      </div>
      <div>
        {/* {showAdvanceFilter ? (
          <AdvanceFilterBlock
            handleChangeParams={handleChangeParams}
            queryParamsOutgoing={queryParamsOutgoing}
          />
        ) : null} */}
        <AppTable
          rowSelection={rowSelection}
          onRow={record => {
            return {
              onClick: () => handleRowClick(record),
            }
          }}
          rowKey={record => record.code}
          dataSource={internalDocumentOutgoingList}
          columns={tableColumns}
          pagination={false}
          locale={{
            emptyText:
              checkPagination === true ? (
                <div>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={'Không có dữ liệu'}
                  />
                  <Button
                    onClick={() => handleChangeParams({ fullText: true })}>
                    Tìm văn bản liên quan
                  </Button>
                </div>
              ) : (
                <div style={{ opacity: 0.1, height: '150px' }} />
              ),
          }}
          loading={{
            tip: 'Đang tải văn bản...',
            spinning: loadingAnimationStore.tableLoading,
          }}
        />

        {!!checkPagination && (
          <AppTablePagination
            onChange={onChangePagination}
            total={internalDocumentOutgoingListTotalCount}
            pageSize={queryParamsOutgoing.size}
            current={queryParamsOutgoing.page + 1}
          />
        )}
      </div>
    </DocumentsLayout>
  )
}

InternalDocumentOutgoingOutgoingDocPage.propTypes = {}

export default memo(
  withRouter(
    inject(
      'internalDocumentStore',
      'loadingAnimationStore',
      'authorityStore',
      'bookStore',
      'selectUserStore',
      'commandStore'
    )(observer(InternalDocumentOutgoingOutgoingDocPage))
  )
)
